module.exports = __webpack_public_path__ + "img/plus_11px_blue.b21612ce.svg";